<script setup lang="ts">
  import { computed } from 'vue';
  import { VueFinalModal } from 'vue-final-modal';
  import { useBranchLogo } from '@/entities/Branch';

  const props = defineProps<{
    title: string;
    text: string;
    logoPath: string;
    branchId: number;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
  }>();

  const { DEFAULT_LOGO, isLogoFailed, markLogoAsFailed } = useBranchLogo();

  const displayLogoPath = computed(() =>
    isLogoFailed(props.branchId) ? DEFAULT_LOGO : props.logoPath
  );

  const handleLogoError = () => {
    markLogoAsFailed(props.branchId);
  };
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="py-4 px-4 flex flex-col bg-white-01 rounded-2xl w-[500px] shadow-lg"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <div class="overflow-auto">
      <div class="flex justify-end">
        <button
          class="text-gray-03"
          @click="emit('close')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="flex flex-col items-center px-14 pb-10">
        <h3 class="text-xl font-medium text-center mb-2">
          {{ title }}
        </h3>
        <p class="text-gray-03 text-center mb-6">
          {{ text }}
        </p>
      </div>
      <div
        id="modal-content"
        class="flex flex-col items-center px-14 pb-10"
      >
        <img
          :src="displayLogoPath"
          alt="Logo"
          class="w-full h-full object-contain mb-7"
          @error="handleLogoError"
        >
      </div>
    </div>
  </VueFinalModal>
</template>
